import { createContext } from 'react';

export type ModuleFeatureContextType = {
    reserveInStore?: boolean;
};

export const ModuleFeatureContext = createContext({ reserveInStore: false });
